<template>
  <div>
    <a-modal v-model="visible" width="560px" :title="innerTagId ? '修改标签' : '添加标签'" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="visible = false">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="名称" prop="name">
          <a-input v-model="modalForm.name" />
        </a-form-model-item>
        <a-form-model-item label="颜色" prop="color">
          <a-input v-model="modalForm.color" />
        </a-form-model-item>
        <a-form-model-item label="标签组" prop="group_id">
          <a-select v-model="modalForm.group_id" style="width: 100%">
            <a-select-option v-for="group in groupItems" :key="group.id" :value="group.id"> {{ group.name }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort">
          <a-input-number v-model="modalForm.sort" style="width: 100%" :min="1" :max="100000" :default-value="1" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { tagAdd, tagModify, tagGroupList } from '@/api/system/tag';

export default {
  name: 'TeamModal',
  data() {
    return {
      loading: false,
      groupItems: [],
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      modalForm: {
        name: null
      },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        color: [{ required: true, message: '颜色不能空', trigger: 'blur' }],
        group_id: [{ required: true, message: '分类不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
      },
      innerTagId: null
    };
  },
  methods: {
    open(tagId = null, tagData = null) {
      this.visible = true;
      this.getGroupList();
      console.log(tagId, tagData);
      if (tagId) {
        this.modalForm = { ...tagData };
        this.innerTagId = tagId;
      } else {
        this.modalForm = { name: null, sort: 1, ...tagData };
        this.innerTagId = null;
      }
    },

    getGroupList() {
      tagGroupList({}).then(res => {
        this.groupItems = res.data.items;
      });
    },

    submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.innerTagId) {
            this.loading = true;
            tagModify({ id: this.innerTagId, ...this.modalForm })
              .then(() => {
                this.$emit('ok');
                this.visible = false;
                this.$message.success('标签修改成功');
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            tagAdd(this.modalForm)
              .then(() => {
                this.$emit('ok');
                this.visible = false;
                this.$message.success('标签添加成功');
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-modal-body {
  padding: 16px 32px 0px 64px;
}
</style>
